<template>
	<div id="Main">
		<!-- 有误银行卡展示的提示语不一样，需要处理 -->
		<div v-if="bank!=''">
			<p class="tisp">当前指定的红利领取银行卡</p>
			<div class="cardbox">
				<van-row type="flex" justify="space-between">
					<van-col>
						<van-icon class="icon bank" :name="require('../../assets/images/service/jianshe.png')" />
						<div class="name">{{bank.bank}}<br /><span>储蓄卡</span></div>
					</van-col>
					<van-col>{{card}}</van-col>
				</van-row>
				<div class="default" v-if="bank.auditStatus!=1">
					{{bank.auditStatusName}}
					<van-icon class="icon" name="checked" />
				</div>
				<div class="default" v-else>
					<van-icon class="icon" name="checked" />
				</div>
			</div>
			<van-button type="info" round="" class="submit" @click="submit(1)">确定</van-button>
			<van-button type="info" round="" class="submit" @click="submit(2)">重新指定红利领取银行卡</van-button>
		</div>
		<div v-else>
			<p class="tisp">您还没有指定领取红利的银行卡，请点击“添加银行卡”指定。</p>
			<p style="color:red;font-size:1.5rem;">注意事项：</p>
			<p class="tisp">1、红利只能转入股东本人名下银行卡，如指定的是非股东本人名下的银行卡，将导致转账失败，无法领取红利。</p>
			<p class="tisp">2、如指定的银行卡为二类账户，有转账金额限制，请确保您申请领取的红利总金额不超过转账金额限制（一般为1万元，具体请咨询发卡银行）。</p>
			<div class="button" @click="add">
				<van-icon name="add" class="icon" />
				添加银行卡
			</div>
		</div>
		
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				user:'',/* 账户号 */
				name:'',
				show:'',
				bank:'',
				card:'',
				type:'',/* 银行卡状态 */
				auditStatusName:'',
				id:'',
			}
		},
		methods: {
			add() {
				this.$router.push({
					path: '/addcard',
					query:{
						user:this.user,
						name:this.name,
					}
				})
			},
			href(){
				this.$router.push({
					path: '/cardtisp',
					query:{
						user:this.user,
						name:this.name,
						id:this.bank.id,
						type:this.bank.auditStatus,
						auditStatusName:this.bank.auditStatusName,
						bank:this.bank.bank,
						card:this.bank.card,
						
					}
				})
			},
			getbank(){
				this.$toast.loading({
					message: '数据加载中...',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getBank({shareholdeCode:this.user}).then((res) => {
					this.$toast.clear();
					window.console.log(res.data)
					if (res.data.code == 200) {
						if(res.data.data.length>0){
							this.bank=res.data.data[0]
							window.console.log()
							this.card='**** '+this.bank.card.substr(this.bank.card.length-4,4)
						}
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			submit(type) {
				// user:this.user,
				// 		name:this.name,
				// 		id:this.bank.id,
				// 		type:this.bank.auditStatus,
				// 		auditStatusName:this.bank.auditStatusName,
				// 		bank:this.bank.bank,
				// 		card:this.bank.card,
				if(type==1){
					if(this.bank.auditStatus!=1){
						this.$toast({duration:4000,message:'此卡'+this.bank.auditStatusName+'，暂时不能领取红利操作！'});
						return false
					}
					this.$router.push({
						path: '/applydividend',
						query:{
							user:this.user,
							name:this.name,
							bank:this.bank.bank,
							card:this.bank.card,
						}
					})
				}else{
					this.$router.push({
						path: '/addcard',
						query:{
							user:this.user,
							name:this.name,
							id:this.bank.id,
						}
					})
				}
			},
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
			this.getbank();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;
		background-color: #f2f9ff;
		min-height: 100vh;
		.bank{
			background-color: #fff;
			border-radius: 50%;
			padding: 0.4rem;
			box-sizing: border-box;
		}
		.cardbox {
			background-color: #747ffe;
			padding: 1rem;
			border-radius: 8px;
			color: #fff;
			.default{
				padding-top: 0.5rem;
				text-align: right;
				.icon{
					font-size: 2.3rem;
					margin-right: 0;
				}
			}
			.name{
				display: inline-block;
				font-size: 1.6rem;
				font-weight: bold;
				span{
					font-size: 1.4rem;
					font-weight: 400;
				}
			}
			.icon{
				font-size: 4.8rem;
				margin-right: 1rem;
				vertical-align: top;
			}
		}

		.tisp {
			font-size: 1.4rem;
			color: rgba(0, 0, 0, .5);
			padding: 0.8rem 0;
		}

		.button {
			background-color: #fff;
			text-align: center;
			padding: 2rem 0;
			color: #fa6b6b;
			font-size: 1.8rem;
			font-weight: bold;
			border-radius: 5px;
			margin-top: 2rem;
			position: relative;

			.icon {
				vertical-align: middle;
				font-size: 2rem;
				margin-right: 0.2rem;
			}

			&:before {
				content: '';
				display: block;
				position: absolute;
				top: 8px;
				left: 8px;
				right: 8px;
				bottom: 8px;
				border: 1px solid #fee9e9;
				border-radius: 5px;
			}
		}
	}
		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 8rem;
			&:last-child{
				margin-top: 2rem;
				margin-bottom: 1rem;
				background-color: transparent;
				color: #fa6b6b;
				border: 1px solid #fa6b6b;
			}
		}

</style>
